<template>
    <div>
        <div class="filter-heading cf">
            <p class="filter-title">
                Price <small>(Exc. VAT)</small> <small v-if="selected.length">({{ selected.length }} applied)</small>
            </p>
        </div>
        <div class="filter-body">
            <div class="checkbox" v-for="tier in items.all" :key="tier.key" v-if="tier.doc_count > 0">
                <label>
                    <input type="checkbox" v-model="selected" :value="value(tier)" @change="bump">
                    <span class="faux-label">
                        <template v-if="tier.from == '0.0'">
                            Less Than <product-price :price="tier.to" :showTax="false" :inline="true"></product-price>
                        </template>
                        <template v-else-if="!tier.to">
                            More Than <product-price :price="tier.from" :showTax="false" :inline="true"></product-price>
                        </template>
                        <template v-else>
                            <product-price :price="tier.from" :showTax="false" :inline="true"></product-price>
                            -
                            <product-price :price="tier.to" :showTax="false" :inline="true"></product-price>
                        </template>
                        <span class="product-count">({{ tier.doc_count }})</span>
                    </span>
                </label>
            </div>
        </div>
        <div class="filter-footer">
            <button @click="expanded = false" v-if="expanded">Show less</button>
            <button @click="expanded = true" v-else-if="hiddenCount">Show {{ hiddenCount }} more </button>
        </div>

    </div>
</template>

<script>
    import ProductPrice from '../../Product/ProductPrice.vue';
    import { PriceFilter } from '../../../Services/Search/PriceFilter.js';

    export default {
        components: {
            ProductPrice
        },
        props: {
            current: {
                type: String,
                default: null,
            },
            expand: {
                type: Boolean,
                default: false,
            },
            handle: {
                type: String,
            },
            items: {
                type: [Object,Array],
                default() {
                    return {
                        all: []
                    };
                }
            }
        },
        mounted() {
            if (this.current) {
                this.expanded = true;
                _.each(this.current.split(':'), item => {
                    this.selected.push(item);
                });
                this.loaded();
            }
        },
        data() {
            return {
                selected: [],
                expanded: false,
            }
        },
        computed: {
            hiddenCount() {
                return this.items.all ? this.items.all.length - this.filters.length : 0;
            },
            filters() {
                if (this.expanded) {
                    return this.items.all;
                }
                return _.take(this.items.all, 5);
            },
        },
        methods: {
            value(range) {
                let value = range.from;
                if (range.to) {
                    value += '-' + range.to;
                }
                return value;
            },
            bump() {
                this.$emit('bump', new PriceFilter(this.selected));
            },
            loaded() {
                this.$emit('loaded', new PriceFilter(this.selected));
            }
        }
    }
</script>

<!--

<template>
    <div v-if="items.all.length > 1">
        <div class="filter-heading cf">
            <p class="filter-title">
                {{ label }} <small v-if="selected.length">({{ selected.length }} applied)</small>
            </p>
            <p class="filter-action">
                <a href="#" @click.prevent="expanded = !expanded" v-if="expanded">Collapse</a>
                <a href="#" @click.prevent="expanded = !expanded" v-else>Expand</a>
            </p>
        </div>
        <div class="filter-body" v-if="expanded">
            <div class="checkbox" v-for="item in items.all" :key="item.key" v-if="item.doc_count">
                <label>
                    <input type="checkbox" v-model="selected" :value="item.key" @change="bump">
                    <span class="faux-label">
                        <span v-html="item.key ? item.key : '-'"></span>
                        <span class="product-count">({{ item.doc_count }})</span>
                    </span>
                </label>
            </div>
        </div>

    </div>
</template>

<script>
    import { TextFilter } from '../../../Services/Search/TextFilter.js';

    export default {
        props: {
            expand: {
                type: Boolean,
                default: false,
            },
            handle: {
                type: String,
            },
            items: {
                type: [Object,Array],
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                selected: [],
                expanded: this.expand,
            }
        },
        mounted() {
            if (this.items.selected) {
                this.expanded = true;
                _.each(this.items.selected, item => {
                    this.selected.push(item.key);
                });
                this.loaded();
            }
        },
        methods: {
            bump() {
                this.$emit('bump', new TextFilter(this.handle, this.selected));
            },
            loaded() {
                this.$emit('loaded', new TextFilter(this.handle, this.selected));
            }
        },
        computed: {
            rows() {
                return this.brands.buckets;
            },
            label() {
                return this.handle.replace('_', ' ').titleCase();
            }
        }
    }
</script>
-->


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/Filters/PriceFilter.vue